export default __webpack_public_path__ + "locales/fi/VersionHistory.json?hash=65b2dfc8cdfe2d4a59e4cf96e2b97bcc";